import { useMutation, useQuery } from "react-query";
import { useMatch } from "react-router-dom";

import {
    deletePaperSearchHistory,
    getPaperRecommendation,
    getPaperSearch,
    getPaperSearchHistory,
} from "utils/request/paper";

const useCurrentSpaceUuid = () => {
    const match = useMatch("/:space_uuid/*");
    return match?.params?.space_uuid ?? "";
};

export const usePaperSearch = (params) => {
    const space_uuid = useCurrentSpaceUuid();
    return useQuery(["paperSearch", space_uuid, params], () => getPaperSearch(space_uuid, params), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
        // 검색 이력이 여러번 저장되는 현상 관련 refetch 조정
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
    });
};

export const usePaperRecommendation = (params) => {
    const space_uuid = useCurrentSpaceUuid();
    return useQuery(["paperRecommendation", space_uuid, params], (e) => getPaperRecommendation(space_uuid, params), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
    });
};

export const usePaperSearchHistory = (params) => {
    const space_uuid = useCurrentSpaceUuid();
    return useQuery(["paperSearchHistory", space_uuid, params], (e) => getPaperSearchHistory(space_uuid, params), {
        staleTime: Infinity,
        cacheTime: Infinity,
        retry: false,
    });
};

export const useDeletePaperSearchHistory = () => {
    const space_uuid = useCurrentSpaceUuid();
    return useMutation((body) => deletePaperSearchHistory(space_uuid, body));
};
